import { Component, Input } from "@angular/core";
import { ProductDetails } from "@brain/models";
import { AssetDetailSectionDirective } from "../asset-section";

@Component({
    selector: "brain-asset-detail-overview",
    templateUrl: "./overview.html",
    styleUrls: ["./overview.scss"]
})
export class AssetDetailOverviewComponent extends AssetDetailSectionDirective {

  public key = "Overview";

  public product: ProductDetails;

  @Input()
  public tags;

  @Input()
  public img;
}
